import * as React from "react";

class ErrorBoundary extends React.Component {
    constructor(props) {
        super(props);
        this.state = { hasError: false };
    }

    refresh()
    {
        window.location.reload();
    }

    componentDidCatch(error, info) {
        console.log("Error occurred")
        this.setState({ hasError: true });
    }

    render() {
        if (this.state.hasError) {
            return <div style={style}> <h1>We are sorry. Something went wrong. You can try <span style={{color:'blue'}}> refresh </span> page or contact support team.</h1> </div>;
        }
        return this.props.children;
    }
}

const style = {
    position: 'absolute',
    left: '50%',
    top: '50%',
    transform: 'translate(-50%, -50%)'
}
export default ErrorBoundary





// WEBPACK FOOTER //
// ./src/ErrorBoundary/ErrorBoundary.js